export const createSubscriptionItem = `
    mutation createSubscriptionItem($input: CreateSubscriptionItemInput!) {
        createSubscriptionItem(input:$input) {
            id
            subscriptionId
            priceId
            quantity
            createdByUsername
            created
            updated
    }
}`;

export const updateSubscriptionItem = `
    mutation updateSubscriptionItem($input: UpdateSubscriptionItemInput!) {
        updateSubscriptionItem(input:$input){
            id
            subscriptionId
            priceId
            quantity
            createdByUsername
            created
            updated
        }
}`;

export const deleteSubscriptionItem = `
    mutation deleteSubscriptionItem($input: DeleteSubscriptionItemInput!) {
        deleteSubscriptionItem(input:$input) 
}`;
